import { Component } from 'preact';
import { connect } from 'preact-redux';
import styled, { ThemeProvider } from 'styled-components';
import 'preact-material-components/style.css';


const Wrapper = styled.div`
    background: ${props => props.theme.colors.backgroundMid};
    width: 100%;
    font-size: 0.6em;
    padding: 0.5em 0;
    height: 5em;
    margin-top: -5em;
`
const Row = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5em 0;

    p {
        color: ${props => props.theme.colors.bodyLight};
        padding: 0;
        margin: 0;
    }
`
const Anchor = styled.a`
    color: ${props => props.theme.colors.bodyLight};
    padding: 0 0.3em;
`

class GlobalFooter extends Component {

    render(props) {
        return (
            <ThemeProvider theme={props.theme}>
                <Wrapper>
                    <Row>

                        {props.pageContent.footer[0].links.map((item) => (
                            <Anchor href={item.url} target={item.internalLink ? '' : "_blank"}>{item.title}</Anchor>
                        ))}

                    </Row>
                    <Row>
                        <p>{props.pageContent.footer[0].copyright}</p>
                    </Row>

                </Wrapper>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = ({ pageContent, theme }) => {
    return { pageContent, theme }
}

export default connect(
    mapStateToProps
)(GlobalFooter)





// WEBPACK FOOTER //
// ./components/footer/GlobalFooter.js